export default "__VITE_ASSET__a73a5bec__"